var _path, _path2, _path3;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgOptions = function SvgOptions(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 6,
    viewBox: "0 0 26 6",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9994 6C24.6562 6 25.9994 4.65685 25.9994 3C25.9994 1.34315 24.6562 0 22.9994 0C21.3425 0 19.9994 1.34315 19.9994 3C19.9994 4.65685 21.3425 6 22.9994 6Z",
    fill: "#292F4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9994 6C14.6562 6 15.9994 4.65685 15.9994 3C15.9994 1.34315 14.6562 0 12.9994 0C11.3425 0 9.99939 1.34315 9.99939 3C9.99939 4.65685 11.3425 6 12.9994 6Z",
    fill: "#292F4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.99939 6C4.65624 6 5.99939 4.65685 5.99939 3C5.99939 1.34315 4.65624 0 2.99939 0C1.34254 0 -0.000610352 1.34315 -0.000610352 3C-0.000610352 4.65685 1.34254 6 2.99939 6Z",
    fill: "#292F4C"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOptions, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/options.916456f1.svg";
export { ForwardRef as ReactComponent };